<script setup lang="ts">
  interface AnchorProps {
    id: string;
    title: string;
    icon: string;
    activeIcon: string;
  }

  defineProps<{
    anchor: AnchorProps[];
    id: string;
  }>();

  const onAnchorClick = (id: string) => {
    const anchorElement = document.getElementById(id);
    if (anchorElement) {
      anchorElement.scrollIntoView({ behavior: "smooth" });
    }
  };
</script>

<template>
  <nav class="anchor-box">
    <a
      v-for="item of anchor"
      :key="item.id"
      class="anchor-item"
      :class="{ 'anchor-item-active': id === item.id }"
      :title="item.title"
      @click="onAnchorClick(item.id)">
      <icon-font :type="id === item.id ? item.activeIcon : item.icon" />
      <!-- <Icon :name="`custom:${id == item.id ? item.activeIcon : item.icon}`" />-->
      <span class="anchor-item-text">{{ item.title }}</span>
    </a>
  </nav>
</template>

<style scoped lang="less">
  .anchor-box {
    --text-display: inline-block;
    --anchor-width: 182px;

    position: fixed;
    top: 50%;
    left: 0;
    z-index: 999;
    width: var(--anchor-width);
    padding: 28px 0;
    cursor: pointer;
    background: #ebf1ff;
    border-radius: 0 12px 12px 0;
    transform: translateY(-50%);

    @media screen and (max-width: 1536px) {
      --text-display: none;
      --anchor-width: 60px;
    }

    @media screen and (max-width: 768px) {
      display: none;
    }

    .anchor-item {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      height: 84px;
      background-color: transparent;
      border-radius: 12px;

      &::before {
        position: absolute;
        top: 50%;
        left: 0;
        display: block;
        width: 6px;
        height: 108px;
        content: "";
        background: #3555fe;
        opacity: 0;
        transform: translateY(-50%);
      }

      .anticon {
        margin-right: 10px;
        font-size: 24px;
        color: #7f89aa;
      }

      span {
        font-size: 18px;
        line-height: 36px;
        color: transparent;
        background-image: linear-gradient(#000, #000);
        background-clip: text;
      }

      span.anchor-item-text {
        display: var(--text-display);
      }
    }

    .anchor-item-active {
      &::before {
        opacity: 1;
      }

      .anticon {
        color: #0a5cff;
      }

      span {
        font-weight: 600;
        background-image: linear-gradient(#0a5cff 0%, #54b7ff 100%);
      }
    }
  }
</style>
